import React from "react";
import { useForm } from "react-hook-form";
import useShipping from "./useShipping"; // Your custom hook

function CreateShipping({ onSetActiveTab }) {
  const { createShippingFn, isCreatingShipping, createShippingError } =
    useShipping();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      governorate: "",
      city: "",
      price: "",
      daysToDeliver: "",
    },
  });

  const onSubmit = (data) => {
    createShippingFn(data, {
      onSuccess: () => {
        reset();
        onSetActiveTab("list");
      },
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="space-y-4 w-full bg-white rounded shadow p-8"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">Governorate</label>
          <input
            {...register("governorate", {
              required: "Governorate is required",
            })}
            placeholder="Governorate"
            className="border p-2 rounded w-full"
          />
          {errors.governorate && (
            <p className="text-red-500 text-sm mt-1">
              {errors.governorate.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">City</label>
          <input
            {...register("city", { required: "City is required" })}
            placeholder="City"
            className="border p-2 rounded w-full"
          />
          {errors.city && (
            <p className="text-red-500 text-sm mt-1">{errors.city.message}</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">Price (EGP)</label>
          <input
            type="number"
            min={0}
            {...register("price", {
              required: "Price is required",
              min: { value: 0, message: "Minimum price is 0" },
            })}
            placeholder="Price"
            className="border p-2 rounded w-full"
          />
          {errors.price && (
            <p className="text-red-500 text-sm mt-1">{errors.price.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Days to Deliver
          </label>
          <input
            type="number"
            min={1}
            {...register("daysToDeliver", {
              required: "Delivery time is required",
              min: { value: 1, message: "Minimum is 1 day" },
            })}
            placeholder="Days"
            className="border p-2 rounded w-full"
          />
          {errors.daysToDeliver && (
            <p className="text-red-500 text-sm mt-1">
              {errors.daysToDeliver.message}
            </p>
          )}
        </div>
      </div>

      <div className="flex gap-4 mt-8">
        <button
          type="submit"
          disabled={isCreatingShipping}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          {isCreatingShipping ? "Creating..." : "Create"}
        </button>
        <button
          type="button"
          onClick={() => onSetActiveTab("list")}
          className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300 transition-colors"
        >
          Cancel
        </button>
      </div>

      {createShippingError && (
        <div className="text-red-500 text-center mt-2">
          {createShippingError.message || "Error creating shipping option"}
        </div>
      )}
    </form>
  );
}

export default CreateShipping;
